// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3dsHO","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3W30I"};